<template>
  <q-section :bg-i="uiMeta?.images?.taskBg" v-bind="uiMeta?.layout?.wrapper?.taskContainer">
    <q-section
      v-for="item in taskBtnPosition"
      v-bind="item.config"
      :bg-i="item.btnBg"
      bg-s="contain"
      bg-r="no-repeat"
      @click="handleToRoom(item.status, item.giftConfig)">
      <q-section v-bind="uiMeta?.layout?.wrapper?.processWrapper" class="ws-nowrap">
        ({{ item.progress }}/{{ item.max_progress === -1 ? '无上限' : item.max_progress }})
      </q-section>
    </q-section>
  </q-section>
</template>

<script setup>
import { useTask } from './use-task'
import { useClientCommonUtils } from '@/ui-runtime/core/composable/use-client-common-utils'

const props = defineProps({
  uiMeta: {
    type: Object,
    default: () => {},
  },
})

const { taskBtnPosition } = useTask(props.uiMeta)
const { toRandomRoom } = useClientCommonUtils()

const handleToRoom = (status, giftConfig) => {
  if (status !== 0) {
    return
  }
  toRandomRoom(giftConfig)
}
</script>

<style scoped lang="scss">
:deep(.van-stepper__input) {
  color: #000;
}

:deep(.van-popup) {
  background-color: transparent;
}
</style>
